// Libraries
import React from 'react';

// Supermove
import {Icon, Space, Styled} from '@supermove/components';
import {ResponsiveType} from '@supermove/hooks';

// App
import IconButton from '@shared/design/components/IconButton';
import Text from '@shared/design/components/Text';

const Row = Styled.View<{responsive: ResponsiveType}>`
  flex-direction: row;
  align-items: center;
  justify-content: ${({responsive}) => (responsive.desktop ? 'flex-start' : 'space-between')};
`;

const NewProjectPageV2ContentHeader = ({
  responsive,
  handleClose,
}: {
  responsive: ResponsiveType;
  handleClose: () => void;
}) => {
  return (
    <React.Fragment>
      <Row responsive={responsive}>
        <IconButton source={Icon.Xmark} onPress={handleClose} isSecondary size={20} />
        {responsive.desktop ? (
          <React.Fragment>
            <Space width={16} />
            <Text.Heading2>New Project</Text.Heading2>
          </React.Fragment>
        ) : (
          <Text.PageHeading>New Project</Text.PageHeading>
        )}
        <Space width={responsive.desktop ? 16 : 8} />
      </Row>
    </React.Fragment>
  );
};

export default NewProjectPageV2ContentHeader;
